import {each, size, uniqBy} from 'lodash';

class bookingListController {
	constructor($bookings,
	            $auth,
	            $translates,
	            $rootScope,
	            $uibModal,
	            $scope) {

		'ngInject';

		this.ready = false;
		this.$bookings = $bookings;
		this.target = 'working';
		this.$rootScope = $rootScope;
		this.$uibModal = $uibModal;
		this.$scope = $scope;
		this.$auth = $auth;
		this.$translates = $translates;
		this.noData = false;
		this.filtersVisible = false;
		this.initComplete = false;

		this.bookings = this.$bookings.collections.bookings;

		this.bookingsToPrintout = [];

		this.datePicker = {
			date: {
				startDate: angular.copy(window.moment().subtract(5, "days")),
				endDate: angular.copy(window.moment().endOf('day'))
			}
		};

		this.datePickerOld = angular.copy(this.datePicker);

		this.language = $translates.getLanguage();
		this.isProgress = false;

		this.$onScrollDown();

		this.tableConfiguration = {
			id: "bookingsTable",
			next_uri: false,
			limit: 25,
			route_operator: null,
			search: "",
			cursor: 1,
			keys: [
				"booking_number",
				"departure_date",
				"booking_status",
				"route",
				"vehicle_number",
			]
		};

		this.$bookings.initReady$.then( () => {
			if (this.isSpeditor) {
				this.tableConfiguration.keys.push(this.$translates.get('customer'));
				this.tableConfiguration.keys.push(this.$translates.get('vat_id'));
				this.$bookings.setMode('SPEDITOR');
			} else {
				this.$bookings._mode = 'STANDARD';
			}

			this.onInitialLoad()
		});

		this.$rootScope.$on('refreshStandardBookings', () => {
			this.tableConfiguration.next_uri = null;
			this.tableConfiguration.next_uri_historical = null;
			this.$onInit()
		});
	}

	getDate(departure_date) {
		return window.moment(departure_date).format("YYYY-MM-DD HH:mm");
	}

	isEmpty() {
		return this.bookings.filter(booking => this.show(booking)).length;
	}

	status(status) {
		return [0, 1, 10].indexOf(status);
	}

	getNew() {
		return this.bookings && this.bookings.filter(book => this.status(book.booking_status) === -1).length
	}

	show(booking) {
		let target = this.target;
		return (
			(target === 'history' && this.status(booking.booking_status) !== -1) ||
			(target === 'working' && this.status(booking.booking_status) === -1)
		);
	}

	toggleFilters() {
		this.filtersVisible = !this.filtersVisible;
	}

	$onUpdate(booking) {
		this.$uibModal.open({
			component: 'booking-update',
			resolve: {
				items: function () {
					return {
						booking: booking
					}
				}
			}
		});
	}

	isAfterhoursForPolsca() {
		const hour = parseInt(new Intl.DateTimeFormat('pl', {
			timeZone: 'Europe/Warsaw',
			hour: 'numeric',
			hour12: false
		}).format(new Date()), 10);
		return hour >= 22 || hour < 8;
	}

	showAfterhoursNote() {
		this.$uibModal.open({
			component: 'afterhours',
			windowClass: 'center-modal',
		});
	}

	$onDelete(booking) {
		if (booking.route_operator === 'POLSCA_EMAIL' && this.isAfterhoursForPolsca()) {
			this.showAfterhoursNote();
			return;
		}

		const {actual_booking_value} = booking;

		this.$uibModal
			.open({
				component: 'destroy',
				size: 'sm',
				windowClass: 'danger',
			})
			.result.then(result => {
			if (result === 'confirm') {
				booking.booking_status = 1;
				if (booking.route_operator === 'POLSCA_EMAIL') {
					booking.booking_status = 2; // pending for manual
				}
				this.$bookings
					.update(booking)
					.then(res => {
						console.log(res);
						const index = this.bookings.findIndex(b => b.id === booking.id)
						this.bookings.splice(index, 1);
						this.$rootScope.$emit('bookingLimitComponentUpdateValue', { method: "update", actual_booking_value });
					})
			}
		});

	}

	$onChangeRangePicker() {
		try {
			if (!angular.equals(this.datePicker, this.datePickerOld)) {
				this.datePickerOld = angular.copy(this.datePicker);
				let date = this.datePicker.date;
				this.$bookings.dates = {
					dateTo: window.moment(date.endDate).format(),
					dateFrom: window.moment(date.startDate).format()
				};
				this.tableConfiguration.next_uri = null;
				this.$onInit();
			}
		} catch (e) {
			console.log(e);
		}
	}

	$onInit(scroll = false) {
		try {
			if (this.initComplete && !this.loading) {
				this.noData = false;
				this.loading = true;

				if (this.target === 'working') {
					return this.$bookings.getBookings(scroll, null, this.tableConfiguration)
						.then(() => {
							this.tableConfiguration.next_uri = this.$bookings.next_uri;
							this.bookings = this.$bookings.collections.bookings;
							this.setTemplate();
							this.loading = false;
							if (this.bookings.length === 0) {
								this.noData = true;
							}
						});
				} else {
					return this.$bookings.getHistoricalBookings(scroll, null, this.tableConfiguration)
						.then(() => {
							this.tableConfiguration.next_uri_historical = this.$bookings.next_uri_historical;
							this.bookings = this.$bookings.collections.historicalBookings;
							this.setTemplate();
							this.loading = false;
							if (this.bookings.length === 0) {
								this.noData = true;
							}
						});
				}
			}
		} catch (e) {
			this.loading = false;
		}
	}

	onInitialLoad() {
		this.operators = this.$bookings.collections.operators;
		this.operator = [this.operators[0].operator_code];
		this.$bookings.operator = this.operator;
		this.tableConfiguration.route_operator = this.operator;

		this.initComplete = true;
		this.$onInit();

		this.$rootScope.$on('$bookingsUnshift', (e, data) => {
			if (!this.isViewActive) {
				return;
			}
			if (this.target !== 'working') {
				return;
			}
			this.$rootScope.$apply(() => {
				if (data.length > 0) {
					for (let i = 0; i < data.length; i++) {
						this.bookings.unshift(data[i]);
						this.setTemplate(this.bookings[i]);
					}
				}
			});
		});
		this.$rootScope.$on('$bookingsUpdate', (e, data) => {
			if (!this.isViewActive) {
				return;
			}
			this.$rootScope.$apply(() => {
				this.bookings.map((book, iterator) => {
					if (book.uri === data.uri) {
						data.payload.onPush = true;
						this.bookings[iterator] = data.payload;
						this.setTemplate(this.bookings[iterator]);
					}
				});
			});
		});
		this.setTemplate();
	}

	filterOperator(operator) {
		this._initial = false;
		const idx = this.operator.indexOf(operator);
		if (idx > -1) {
			this.operator.splice(idx, 1);
		} else {
			this.operator.push(operator);
		}
		this.$bookings.operator = this.operator;
		this.tableConfiguration.route_operator = this.operator;
		this.tableConfiguration.next_uri = null;
		this.$onInit();
	}

	isOperatorActive(operator) {
		return operator && this.operator.indexOf(operator) > -1;
	}

	$refreshBooking(booking) {
		booking.$refresh = true;
		this.$bookings.activeGet(booking.uri)
			.then(_booking => {
				this.bookings.map((book, iterator) => {
					if (book.uri === _booking.uri) this.bookings[iterator] = _booking;
				});
			});
	}

	$onScrollDown() {
		this.$scope.$watch('bookingList.waypoints.name.down', (n, o) => {
			if (n && n !== o) {
				try {
					this.loading = true;
					this.$bookings.getBookings(true).then(() => this.loading = false);
				} catch (e) {
					this.loading = false;
				}
			}
		});
	}

	hasOperator(operator) {
		return this.$auth.getUser().operators.indexOf(operator) > -1;
	}

	setTemplate(booking) {

		let setBookingExtraInfo = function (booking) {
			if (booking.booking_status === 10 && booking.extra_info !== '') {
				let extraInfo = JSON.parse(booking.extra_info),
					driverList = '',
					consignmentList = `<table class="table table-condensed"><thead><tr><th style="width: 160px">Nazwa</th><th>Ilość</th><th>Waga</th><th>ADR</th></tr></thead><tbody>`;

				if (extraInfo) {
					each(extraInfo.driver, driver => driverList = `${driverList}&nbsp;&nbsp;${driver.name}<br>`);
					each(extraInfo.consignment, consignment => consignmentList = `${consignmentList}<tr><td>${consignment.desc}</td><td>${consignment.qty}</td><td>${consignment.weight}</td><td>${consignment.imo ? 'TAK' : 'NIE'}</td></tr>`);
					consignmentList = `${consignmentList}</tbody></table>`;
				} else {
					driverList = `${driverList}&nbsp;&nbsp;Brak danych<br>`;
					consignmentList = '&nbsp;&nbsp;Brak danych<br>';
				}

				Object.assign(booking, {
					template: `
          <h3>Kierowcy:</h3>
          <p>${driverList}</p>
          <h3>Ładunek:</h3>${consignmentList}
        `
				})
			}
		};
		booking ? setBookingExtraInfo(booking) : this.bookings && this.bookings.map(booking => setBookingExtraInfo(booking));
	}

	$setForPrintout($event, entity) {
		if ($event.target.checked) {
			this.bookingsToPrintout.push(entity.uri);
		} else {
			this.bookingsToPrintout.splice(this.bookingsToPrintout.indexOf(entity.uri), 1);
		}
	}

	isForPrintout(uri) {
		return this.bookingsToPrintout.includes(uri);
	}

	$print() {
		this.$bookings.getBookingConfirmation(this.bookingsToPrintout).then(data => {
			const downloadLink = document.createElement('a');
			downloadLink.href = window.URL.createObjectURL(data);
			downloadLink.setAttribute('download', 'Potwierdzenie rezerwacji.pdf');
			document.body.appendChild(downloadLink);
			downloadLink.click();
			downloadLink.remove();
			this.bookingsToPrintout = [];
		});
	}

	get colSpan() {
		return this.tableConfiguration.keys.length + 2;
	}

	getNextUri() {
		return this.target === 'working' ? this.tableConfiguration.next_uri : this.tableConfiguration.next_uri_historical;
	}

	hideEdit(booking) {
		if (['FREIGHT_FERRY', 'ASTAADRIA'].includes(booking.route_operator)) {
			return true;
		} else
		if (this.target === 'history') {
			return true;
		} else if ([-1, 10, 1].includes(booking.booking_status)) {
			return true;
		} else return booking.booking_status === 9 && booking.booking_number === '';
	}

	hideCancel(booking) {
		if (['FREIGHT_FERRY', 'ASTAADRIA'].includes(booking.route_operator)) {
			return true;
		} else
		if (this.target === 'history') {
			return true;
		} else if ([1, 10].includes(booking.booking_status)) {
			return true;
		} else return booking.booking_status === 9 && booking.booking_number === '';
	}

	switchView(target) {
		this.target = target;
		this.tableConfiguration.next_uri = null;
		this.tableConfiguration.next_uri_historical = null;
		this.$onInit(false);
	}

	get isViewActive() {
		return this.$bookings.mode === 'STANDARD';
	}

	getOperatorLogo(operator) {
    	return operator.logo || `${operator.operator_code.toLowerCase()}.svg`
  	}

	getOperatorLogoFromRoute(routeUri, bookingOperator) {
		const routes = this.$bookings.collections.routes;
		const route = routes.find(route => route.uri === routeUri);
		if (route) {
			if (route.operator_alt) {
				const operator = this.$bookings.collections.operators.find(op => op.operator_code_alt === route.operator_alt);
				return operator.logo ? operator.logo : `${operator}.svg`;
			} else {
				return `${route.operator.toLowerCase()}.svg`;
			}
		} else {
			return `${bookingOperator.toLowerCase()}.svg`;
		}
	}


	get isSpeditor() {
    	return this.$auth.userHasRole('spedytor');
	  }
}


export default bookingListController;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-list/booking-list.controller.js
 **/